import { createAsyncThunk } from "@reduxjs/toolkit"
import { API_ROUTES } from "../../../utility/api.routes"
import apiClient from '../../../services/axois'

export const getFacultyProfile = createAsyncThunk('facultyProfile/getFacultyProfile', async (facultyId) => {
    try {
      const url = API_ROUTES.FACULTY_PROFILE.GET_FACULTY_PROFILE(facultyId)
      const response = await apiClient.get(url)
      return response?.data?.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  })

export const getFacultyBankDetails = createAsyncThunk('facultyProfile/getFacultyBankDetails', async (facultyId) => {
  try {
    const url = API_ROUTES.FACULTY_PROFILE.GET_FACULTY_BANK_DETAIL(facultyId)
    const response = await apiClient.get(url)
    return response?.data?.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getFacultyProfilePhoto = createAsyncThunk('facultyProfile/getFacultyProfilePhoto', async (facultyId) => {
  try {
    const url = API_ROUTES.FACULTY_PROFILE.GET_FACULTY_PROFILE_PHOTO(facultyId)
    const response = await apiClient.get(url)
    return response?.data?.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const updateFacultyProfilePhoto = createAsyncThunk('facultyProfile/updateFacultyProfilePhoto', async ({ profilePhoto, facultyId ,dispatch}) => {
  try {
    const url = API_ROUTES.FACULTY_PROFILE.PUT_FACULTY_PROFILE_PHOTO(facultyId);
    const formData = new FormData();
    formData.append('file', profilePhoto);
    await apiClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    dispatch(getFacultyProfilePhoto(facultyId))
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})